import React from 'react'
import OTPInput from '../OTPInput'
import {
  OtpTitle,
  WrongOtpSpan,
  ResendMessage,
  LoginButton,
  HelpText,
  ActionButtons,
  ResendOtp,
  ResendOtpEnabled,
  StyledWhatsappIcon,
  ChangeNumber,
} from './styles'
import Loader from '../Loader'

const OtpPage = ({
  otpError,
  isOtpResent,
  handleChangeOtp,
  handleKeyPress,
  handleOtpCheck,
  otp,
  isOtpProcessing,
  phone,
  secondsRemaining,
  handlePhoneOtpRequestSend,
  isOtpResendProcessing,
}) => {
  return (
    <>
      <OtpTitle>
        Enter your Code{' '}
        {otpError && <WrongOtpSpan> - incorrect OTP</WrongOtpSpan>}
        {isOtpResent && !otpError && (
          <ResendMessage> - OTP sent on whatsapp</ResendMessage>
        )}
      </OtpTitle>

      <OTPInput
        autoFocus
        isNumberInput
        length={6}
        onChangeOTP={(otp) => handleChangeOtp(otp)}
        onKeyDown={(e) => handleKeyPress(e, !isOtpProcessing, handleOtpCheck)}
        inputClassName={otpError ? 'error' : ''}
      />
      <LoginButton onClick={handleOtpCheck} disabled={otp.length !== 6}>
        {isOtpProcessing ? (
          <Loader size="sm" invertColor noPadding />
        ) : (
          'continue'
        )}
      </LoginButton>

      {!isOtpResent ? (
        <HelpText>We sent a SMS with a 6-digit code to +{phone}</HelpText>
      ) : (
        <HelpText>We sent the 6-digit code to whatsapp on +{phone}</HelpText>
      )}
      <ActionButtons>
        {secondsRemaining ? (
          <ResendOtp>RESEND OTP in {secondsRemaining} s</ResendOtp>
        ) : (
          <ResendOtpEnabled
            id="otp-handler"
            onClick={() => handlePhoneOtpRequestSend(true)}
          >
            {isOtpResendProcessing ? (
              <Loader size="sm" noPadding />
            ) : (
              <>
                {'RESEND OTP on '} <StyledWhatsappIcon />
              </>
            )}
          </ResendOtpEnabled>
        )}
        <ChangeNumber href="/">EDIT NUMBER</ChangeNumber>
      </ActionButtons>
    </>
  )
}

export default OtpPage
